<!--
 * @Author: cuixuecheng
 * @Date: 2023-10-25 10:24:39
 * @LastEditors: cuixuecheng
 * @LastEditTime: 2024-06-13 10:03:55
 * @Description: 
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
